import Repository from "./Repository";
import BaseResponse from "../types/BaseResponse";
import Company from "../types/Company";
import Employee from "../types/Employee";

const resource = "/questionReview";

export default {
  getCompanies() {
    return Repository.get<BaseResponse<Company[]>>(`${resource}/companies`);
  },

  searchEmployees(
    companyId: string,
    keyword: string
  ) {
    return Repository.get<BaseResponse<Employee[]>>(
      `${resource}/search/employeeBy/${companyId}?keyword=${keyword}`
    );
  }
};